// extracted by mini-css-extract-plugin
export default {"ExtraPerformanceAdviceSection":"style_ExtraPerformanceAdviceSection__nlWYl","GlobalText2":"style_GlobalText2__zGQl0"};